'use strict';

angular.module('AcaApp').factory('ShortcutsService',
[
  function(){
    return{
      disableBackSpaceDefault: function(){
        var excludeElements = /INPUT|TEXTAREA/i;
        $(document).bind('keydown keypress', function(e){
          if(e.which == 8){ // 8 == backspace
            if(!excludeElements.test(e.target.tagName) || e.target.disabled || e.target.readOnly){
              e.preventDefault();
            }
          }
        });
      },
      enableBackSpaceDefault: function(){
        $(document).unbind('keydown keypress');
      }
    };
  }
]);